import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';

import { Store } from '@ngrx/store';
import { filter } from 'rxjs';
import { map } from 'rxjs/operators';

import {
  SignupActiveScreen,
  SignupService
} from '@app/pages/signup/services/signup.service';
import { appFeature } from '@app/core/store/app.reducer';
import { CompanyStatus } from '@app/shared/enums/company.enums';

export const nonAuthGuard: CanActivateFn = () => {
  const store = inject(Store);
  const oAuthService = inject(OAuthService);
  const signupService = inject(SignupService);
  const router = inject(Router);

  if (oAuthService.hasValidAccessToken() || router.url === '/instructions') {
    return store.select(appFeature.selectUser).pipe(
      filter(Boolean),
      map(user => {
        if (user.company) {
          switch (user.company.companyStatus) {
            case CompanyStatus.Unregistered: {
              signupService.signupActiveScreen.next(
                SignupActiveScreen.RegisterCompany
              );
              return true;
            }
            case CompanyStatus.PendingUploadingFiles: {
              signupService.signupActiveScreen.next(
                SignupActiveScreen.Documents
              );
              return true;
            }
            case CompanyStatus.PendingSelectingCategories: {
              signupService.signupActiveScreen.next(
                SignupActiveScreen.Categories
              );
              return true;
            }
            case CompanyStatus.Confirmed: {
              return true;
            }
            default: {
              return false;
            }
          }
        } else {
          signupService.signupActiveScreen.next(
            SignupActiveScreen.RegisterCompany
          );
          return true;
        }
      })
    );
  } else {
    return true;
  }
};
